import { jsx as _jsx } from "react/jsx-runtime";
import { Pencil as PencilIcon } from "@air/next-icons";
import { Button } from "@air/primitive-button";
import { IconButton } from "@air/primitive-icon-button";
import { useBreakpointsContext } from "@air/provider-media-query";
import { useAirModal } from "@air/provider-modal";
import { hasSelectedItemsSelector } from "@air/redux-selected-items";
import { memo } from "react";
import { useSelector } from "react-redux";
import { ACTION_BAR_EDIT } from "~/constants/testIDs";
import { boardCollectionFormSelector } from "~/store/boardCollection/selectors";
import { selectedClipsSelector } from "~/store/selectedItems/selectors";
import { useAirStore } from "~/utils/ReduxUtils";
import { BoardCollectionGalleryAssetDetailsModal } from "./BoardCollectionGalleryAssetDetailsModal";
export const BoardCollectionEditButton = /*#__PURE__*/ memo(()=>{
    const store = useAirStore();
    const hasSelectedItems = useSelector(hasSelectedItemsSelector);
    const { isAboveMediumScreen } = useBreakpointsContext();
    const [showBoardCollectionGalleryAssetDetailsModal] = useAirModal(BoardCollectionGalleryAssetDetailsModal);
    const form = useSelector(boardCollectionFormSelector);
    if (!(form === null || form === void 0 ? void 0 : form.fields.some((field)=>field.type === "custom_field"))) {
        return null;
    }
    if (isAboveMediumScreen) {
        return /*#__PURE__*/ _jsx(Button, {
            appearance: "ghost",
            color: "grey",
            size: "large",
            prefix: /*#__PURE__*/ _jsx(PencilIcon, {
                className: "size-4"
            }),
            onClick: ()=>showBoardCollectionGalleryAssetDetailsModal({
                    clips: selectedClipsSelector(store.getState())
                }),
            disabled: !hasSelectedItems,
            "data-testid": ACTION_BAR_EDIT,
            children: "Edit"
        });
    }
    return /*#__PURE__*/ _jsx(IconButton, {
        appearance: "ghost",
        className: "mr-2",
        color: "grey",
        "data-testid": ACTION_BAR_EDIT,
        disabled: !hasSelectedItems,
        icon: PencilIcon,
        label: "Edit",
        onClick: ()=>showBoardCollectionGalleryAssetDetailsModal({
                clips: selectedClipsSelector(store.getState())
            }),
        size: "large"
    });
});
BoardCollectionEditButton.displayName = "BoardCollectionEditButton";
